export default "__VITE_ASSET__2X2$pg4B__"